import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../analyticsUtils';
import { getRequest } from '../../requestUtils';
import TableDisplay from './TableDisplay/TableDisplay';
import loading from '../../../assets/images/spinner-DNA-2s-200px.svg';
import searchIcon from '../../../assets/images/search-icon-white.svg';
import './ProjectProposalsTab.scss';
var emptyStateTitle = function emptyStateTitle(title, proposalOrProjectInv) {
  if (title === 'Applications') return title;
  return proposalOrProjectInv === 'proposal' && title === 'Proposals' ? 'Proposals' : 'Project Invitation';
};
var ProjectProposalsTab = /*#__PURE__*/function (_Component) {
  function ProjectProposalsTab(props) {
    var _this;
    _classCallCheck(this, ProjectProposalsTab);
    _this = _callSuper(this, ProjectProposalsTab, [props]);
    _this.state = {
      count: 10,
      proposals: [],
      consultantInterests: [],
      isLoaded: false,
      proposalOrProjectInv: 'proposal',
      applicationSearchTerm: '',
      isSearching: false,
      searchResult: false
    };
    _this.getProjectApplications = _this.getProjectApplications.bind(_this);
    _this.handleChangeView = _this.handleChangeView.bind(_this);
    _this.renderTableContent = _this.renderTableContent.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.handleClearSearchInput = _this.handleClearSearchInput.bind(_this);
    return _this;
  }
  _inherits(ProjectProposalsTab, _Component);
  return _createClass(ProjectProposalsTab, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getProjectApplications();
    }
  }, {
    key: "getProjectApplications",
    value: function getProjectApplications() {
      var _this2 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        csrfToken = _this$props.csrfToken;
      return getRequest("/projects/".concat(projectResourceId, "/proposal_tab"), csrfToken).then(function (_ref) {
        var data = _ref.data;
        _this2.setState({
          proposals: data.proposals,
          consultantInterests: data.consultant_interests,
          projectInvitations: data.project_invitations,
          csrfToken: data.csrfToken,
          employmentType: data.employment_type,
          isLoaded: true,
          applicationSearchTerm: '',
          searchResult: false
        });
        analyticsTrack('Viewed proposals tab', {
          location: 'Projects view'
        });
      });
    }
  }, {
    key: "handleChangeView",
    value: function handleChangeView(selected) {
      this.setState({
        proposalOrProjectInv: selected
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(name, value) {
      this.setState(_defineProperty({}, name, value));
    }
  }, {
    key: "handleSearch",
    value: function handleSearch() {
      var _this3 = this;
      var _this$props2 = this.props,
        searchUrl = _this$props2.searchUrl,
        csrfToken = _this$props2.csrfToken;
      var applicationSearchTerm = this.state.applicationSearchTerm;
      this.setState({
        isSearching: true
      });
      getRequest("".concat(searchUrl, "?keyword=").concat(applicationSearchTerm), csrfToken).then(function (_ref2) {
        var data = _ref2.data;
        _this3.setState({
          consultantInterests: data,
          isSearching: false,
          searchResult: true
        });
      })["catch"](function () {
        _this3.setState({
          isSearching: false
        });
      });
    }
  }, {
    key: "handleClearSearchInput",
    value: function handleClearSearchInput() {
      this.getProjectApplications();
    }
  }, {
    key: "renderTableContent",
    value: function renderTableContent(title, content) {
      var searchResult = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props3 = this.props,
        csrfToken = _this$props3.csrfToken,
        projectId = _this$props3.projectId,
        projectsOptions = _this$props3.projectsOptions,
        projectResourceId = _this$props3.projectResourceId,
        isCollaborator = _this$props3.isCollaborator,
        cloraRepName = _this$props3.cloraRepName;
      var _this$state = this.state,
        proposalOrProjectInv = _this$state.proposalOrProjectInv,
        employmentType = _this$state.employmentType;
      if (content.length === 0 && searchResult) {
        return /*#__PURE__*/React.createElement("p", {
          className: "proposals-empty"
        }, "No results found.");
      }
      if (content.length === 0) {
        return /*#__PURE__*/React.createElement("p", {
          className: "proposals-empty"
        }, "No", ' ', emptyStateTitle(title, proposalOrProjectInv), ' ', "have been submitted for this project.");
      }
      return /*#__PURE__*/React.createElement(TableDisplay, {
        title: title,
        tableContents: content,
        count: content.length,
        csrfToken: csrfToken,
        projectId: projectId,
        proposalOrProjectInv: proposalOrProjectInv,
        employmentType: employmentType,
        projectsOptions: projectsOptions,
        projectResourceId: projectResourceId,
        isCollaborator: isCollaborator,
        cloraRepName: cloraRepName,
        cloraRep: this.props.cloraRep,
        onApproved: this.getProjectApplications
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$state2 = this.state,
        proposals = _this$state2.proposals,
        consultantInterests = _this$state2.consultantInterests,
        isLoaded = _this$state2.isLoaded,
        projectInvitations = _this$state2.projectInvitations,
        proposalOrProjectInv = _this$state2.proposalOrProjectInv,
        applicationSearchTerm = _this$state2.applicationSearchTerm,
        isSearching = _this$state2.isSearching,
        searchResult = _this$state2.searchResult;
      var _this$props4 = this.props,
        projectId = _this$props4.projectId,
        cloraRep = _this$props4.cloraRep;
      var activeOrPendingRequests = proposalOrProjectInv === 'proposal' ? proposals : projectInvitations;
      if (!isLoaded) {
        return /*#__PURE__*/React.createElement("div", {
          className: "g-flex-8 project-info-column"
        }, /*#__PURE__*/React.createElement("div", {
          className: "loading"
        }, /*#__PURE__*/React.createElement("img", {
          src: loading,
          alt: "Loading_image"
        })));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "g-flex-8 project-info-column project-proposal-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposals-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposals-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposals-title-group"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "project-section-title"
      }, "Proposals"), /*#__PURE__*/React.createElement("p", {
        className: "proposals-subtitle"
      }, "Manage proposals submitted by consultants.")), cloraRep && /*#__PURE__*/React.createElement("a", {
        href: "/proposals/clora_new?project_id=".concat(projectId),
        className: "btn btn-primary proposals-add-btn proposals-add-btn--mobile"
      }, "+ Add a New Proposal")), /*#__PURE__*/React.createElement("div", {
        className: "proposals-controls"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposals-tabs"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this4.handleChangeView('proposal');
        },
        className: "proposals-tab ".concat(proposalOrProjectInv === 'proposal' ? 'proposals-tab--active' : '')
      }, "Active (".concat(proposals.length, ")")), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this4.handleChangeView('projectInv');
        },
        className: "proposals-tab ".concat(proposalOrProjectInv === 'projectInv' ? 'proposals-tab--active' : '')
      }, "Pending Requests (".concat(projectInvitations ? projectInvitations.length : 0, ")"))), cloraRep && /*#__PURE__*/React.createElement("a", {
        href: "/proposals/clora_new?project_id=".concat(projectId),
        className: "btn btn-primary proposals-add-btn proposals-add-btn--desktop"
      }, "+ Add a New Proposal")), this.renderTableContent('Proposals', activeOrPendingRequests)), cloraRep && /*#__PURE__*/React.createElement("div", {
        className: "proposals-card proposals-card--applications"
      }, /*#__PURE__*/React.createElement("div", {
        className: "applications-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "applications-title-group"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "project-section-title"
      }, "Applications"), /*#__PURE__*/React.createElement("span", {
        className: "applications-count"
      }, consultantInterests.length, ' ', consultantInterests.length === 1 ? 'Consultant' : 'Consultants')), /*#__PURE__*/React.createElement("div", {
        className: "input-with-symbol"
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        onChange: function onChange(event) {
          return _this4.handleChange('applicationSearchTerm', event.target.value);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === 'Enter' && applicationSearchTerm !== '') _this4.handleSearch();
        },
        value: applicationSearchTerm,
        placeholder: "Enter search keyword"
      }), applicationSearchTerm !== '' && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-times clear-btn",
        role: "button",
        tabIndex: 0,
        onClick: this.handleClearSearchInput
      }), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: this.handleSearch,
        disabled: applicationSearchTerm === '',
        "aria-label": "Search applications",
        className: "proposals-search-btn"
      }, /*#__PURE__*/React.createElement("img", {
        src: searchIcon,
        alt: ""
      })))), isSearching ? /*#__PURE__*/React.createElement("div", {
        className: "loading"
      }, /*#__PURE__*/React.createElement("img", {
        src: loading,
        alt: "Loading_image"
      })) : this.renderTableContent('Applications', consultantInterests, searchResult)));
    }
  }]);
}(Component);
ProjectProposalsTab.propTypes = {
  projectResourceId: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  cloraRep: PropTypes.bool.isRequired,
  projectsOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchUrl: PropTypes.string.isRequired,
  cloraRepName: PropTypes.string.isRequired,
  isCollaborator: PropTypes.bool
};
ProjectProposalsTab.defaultProps = {
  isCollaborator: false
};
export default ProjectProposalsTab;